import { NavigationItem } from "@/navigation/types";
import hubConfig from "@/navigation/hubNavigation";
import adminConfig from "@/navigation/adminNavigation";
import stochasticConfig from "@/navigation/stochasticNavigation";
import coachingConfig from "@/navigation/coachingNavigation";
import eventRegistrationConfig from "@/navigation/eventRegistrationNavigation";
import learningCenterConfig from "@/navigation/learningCenterNavigation";

const allSectionConfigs = [
  eventRegistrationConfig,
  learningCenterConfig,
  hubConfig,
  coachingConfig,
  stochasticConfig,
  adminConfig,
];

function flattenNavigationItems(items: NavigationItem[]): NavigationItem[] {
  const result: NavigationItem[] = [];
  items.forEach((item) => {
    result.push(item);
    if (item.children) {
      result.push(...flattenNavigationItems(item.children));
    }
  });
  return result;
}

export interface SectionResult {
  sectionName: string;
  defaultRoute: string;
}

export function getSectionFromPath(path: string): SectionResult | null {
  for (const { sectionName, defaultRoute, navigation } of allSectionConfigs) {
    const flattenedItems = flattenNavigationItems(navigation);
    const isMatch = flattenedItems.some(
      (item) => item.href !== "#" && path.startsWith(item.href),
    );
    if (isMatch) {
      return { sectionName, defaultRoute };
    }
  }
  return null;
}

export function filterNavigationByAccess(
  items: NavigationItem[],
  hasPermission: (permission: string) => boolean,
  hasCertainPathCompany: boolean,
  hasCertainPathEmployee: boolean,
): NavigationItem[] {
  return items
    .filter((item) => {
      // Check permissions
      let permissionsPass = true;
      if (item.permissions && item.permissions.length > 0) {
        permissionsPass = item.permissions.some((p) => hasPermission(p));
      }

      // Check CertainPath-only items (active company)
      let cpPass = true;
      if (item.isCertainPathOnly) {
        cpPass = hasCertainPathCompany;
      }

      // Check CertainPath-staff-only items (employee's own company)
      let cpEmployeePass = true;
      if (item.isCertainPathEmployeeOnly) {
        cpEmployeePass = hasCertainPathEmployee;
      }

      return permissionsPass && cpPass && cpEmployeePass;
    })
    .map((item) => ({
      ...item,
      children: item.children
        ? filterNavigationByAccess(
            item.children,
            hasPermission,
            hasCertainPathCompany,
            hasCertainPathEmployee,
          )
        : undefined,
    }));
}
